import { FC } from "react";
import { SettingPageWrapper } from "@connectedComponents";
import { NavigationPathsEnum } from "@utilities/enums";
import { MyAccountForm, PasswordChange } from "./components";
import { useControllers } from "./useControllers";

export const MyAccountSettings: FC = () => {

    const {
        // Updated user infos,
        user, isUserInfosIsComplete,
        isLoadingUpdatedUser,
        updateUserError,
        isEditing, isValidUpdatedUserDataForm,
        firstname, setFirstname,
        lastname, setLastname,
        phone, setPhone,
        email, setEmail,
        birth, setBirth,
        onToggleEdit,
        handleUpdatedUserInfos,  

        // Updated user password
        isLoadingPasswordChange,
        updateUserPasswordError,
        isEditingUpdatePassword, setIsEditingUpdatePassword,
        isValidToUpdatingPassword, setIsValidToUpdatingPassword,
        currentPassword, setCurrentPassword,
        newPassword, setNewPassword,
        confirmPassword, setConfirmPassword,
        onToggleEditingUpdatedPassword, handleUpdatePassword,
    } = useControllers();

    return (
        <SettingPageWrapper activeTab={NavigationPathsEnum.SETTINGS_MY_ACCOUNT}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-4">
                <div className="lg:col-span-2">
                    <h1 className="text-2xl font-bold mb-3">Mon Espace</h1>
                </div>

                <div className="flex flex-col space-y-6 lg:space-y-0">
                    <MyAccountForm 
                        user={user} 
                        isUserInfosIsComplete={isUserInfosIsComplete}
                        isLoadingUpdatedUser={isLoadingUpdatedUser}
                        updateUserError={updateUserError}
                        isEditing={isEditing} 
                        isValid={isValidUpdatedUserDataForm}
                        firstname={firstname} 
                        setFirstname={setFirstname}
                        lastname={lastname} 
                        setLastname={setLastname}
                        phone={phone} 
                        setPhone={setPhone}
                        email={email} 
                        setEmail={setEmail}
                        birth={birth} 
                        setBirth={setBirth}
                        onToggleEdit={onToggleEdit}
                        handleUpdatedUserInfos={handleUpdatedUserInfos}  
                    />
                </div>

                <div className="flex flex-col">
                    <PasswordChange 
                        updateUserPasswordError={updateUserPasswordError}
                        isLoadingPasswordChange={isLoadingPasswordChange}
                        isEditingUpdatePassword={isEditingUpdatePassword} 
                        setIsEditingUpdatePassword={setIsEditingUpdatePassword}
                        isValidToUpdatingPassword={isValidToUpdatingPassword} 
                        setIsValidToUpdatingPassword={setIsValidToUpdatingPassword}
                        currentPassword={currentPassword} 
                        setCurrentPassword={setCurrentPassword}
                        newPassword={newPassword} 
                        setNewPassword={setNewPassword}
                        confirmPassword={confirmPassword} 
                        setConfirmPassword={setConfirmPassword}
                        onToggleEditingUpdatedPassword={onToggleEditingUpdatedPassword} 
                        handleUpdatePassword={handleUpdatePassword}
                    />
                </div>
            </div>
        </SettingPageWrapper>
    );
};
